import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ccc079e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overlay" }
const _hoisted_2 = { class: "overlay-right" }
const _hoisted_3 = { class: "overlay-right-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"bold"} }, "任务详情", -1))
const _hoisted_5 = {
  key: 0,
  class: "rectitle"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rectitle-text" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"16px","color":"#ea0d0d"} }, "不可结算"),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"14px"} }, " 数据检测不合格，系统已自动拦截 ")
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-warning",
  style: {"color":"#ff4949"}
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "图片查重提示：", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ff4949"} }, "*", -1))
const _hoisted_11 = { class: "overlay-right-main__reuqire" }
const _hoisted_12 = { class: "overlay-right-main__reuqire-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "终端服务人员：", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin":"0 1px"} }, null, -1))
const _hoisted_15 = { class: "overlay-right-main__reuqire-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "任务提交时间：", -1))
const _hoisted_17 = {
  key: 0,
  class: "overlay-right-main__reuqire-item"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "结算金额：", -1))
const _hoisted_19 = { class: "overlay-right-main__info" }
const _hoisted_20 = { class: "overlay-right-main__info-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin":"24px 0"} }, "问卷详情", -1))
const _hoisted_22 = {
  key: 0,
  class: "overlay-right-footer"
}
const _hoisted_23 = { class: "overlay-left" }

import {
  withDefaults,
  watch,
  ref,
  nextTick,
  computed,
  onMounted,
  onUnmounted
} from 'vue';
import { storeToRefs } from 'pinia';
import { BaseSvg } from '@/components/base/base-svg/index';
import { useTaskAudit } from '../hooks/useTaskAudit';
import {
  BaseButton,
  BaseImageViewer,
  BaseRow,
  createDialog
} from 'xrk-components';
import { questionDetailComps } from '../components/question-detail-comps';
import { ProjectType } from '../types';
import { formatter } from '@/utils';
import {
  taskRecordUpdateMap,
  selectSimilartList,
  taskRecordDetail
} from '../data-source/apis';
import DeefMap from './deef-map.vue';
import CPreview from './c-preview.vue';
import RepeatPickure from './repeat-pickure.vue';

import appStore from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'task-detail',
  props: {
    id: {},
    dataState: {},
    projectId: {},
    projectType: {},
    searchVal: {},
    remove: {},
    canAudit: { type: Boolean },
    isShowMapHandleBtn: { type: Boolean, default: true }
  },
  emits: ['auditOver', 'refresh'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// 工业-1 服务商-2 供应商-3
const { defaultUserFnCode } = storeToRefs(appStore.useUserStoreSetup);

/**
 * 是否是服务商
 */
const isAsp = computed(() => defaultUserFnCode.value === 2);
/**
 * 是否是工业
 */
// const isIndustry = computed(() => defaultUserFnCode.value === 1);

const isUnqualified = computed(
  () =>
    taskDetail.value?.dataState == 0 &&
    taskDetail.value?.isOverdue == 0 &&
    +taskDetail.value?.superviseStatus !== 1
); // 数据检测不合格，系统拦截);

const repitImgIds = ref([]); // 重复图片id集合
const repitImgList = ref({}); // 重复图片

const showPreviewName = ref(
  props.projectType === 17 ? 'informationShow' : 'imgViewerShow'
);

const isPicRepeat = computed(() => {
  return !!Object.keys(repitImgIds.value).length;
});
const getRepitImgList = async () => {
  const { data } = await selectSimilartList({
    projectId: props.projectId,
    taskIdList: [props.id]
  });
  repitImgList.value = data || {};
  repitImgIds.value = Object.keys(repitImgList.value);
};
getRepitImgList();
const repeatPickurePerview = () => {
  createDialog({
    width: 1500,
    title: '图片重复关联项目',
    showClose: true,
    contentRender: () => {
      return (
        <div style="padding: 20px;">
          <RepeatPickure
            projectId={props.projectId}
            taskId={props.id}
            similarTaskIdList={repitImgList.value[props.id]}
          ></RepeatPickure>
        </div>
      );
    },
    beforeConfirm: async done => {
      done();
    }
  });
};

const auditShow = computed(() => {
  return props.canAudit && isAsp.value;
});

const compNames = computed(() => {
  return questionDetailComps(props.projectType);
});

function convertValuesToJsonArray(data: any[]): any[] {
  return data.map(item => {
    try {
      // 尝试将 values 字段解析为 JSON
      const parsedValues = JSON.parse(item.values);
      const parsedOptions = JSON.parse(item.optionJson);

      item.values = parsedValues;
      item.optionJson = parsedOptions;
    } catch (error) {
      // 如果解析失败，保持原样
    }
    return item;
  });
}
const taskDetail = ref<any>({});

const questionDetailInfo = computed(() => {
  return convertValuesToJsonArray(
    taskDetail.value?.questionnaireInFoDTOS || []
  );
});
// const body = document.body;

const showIndex = ref(0);
const emits = __emit;

const onChangeImgUrl = url => {
  // 查找url在于picList
  const index = picList.value.findIndex(item => item === url);
  onChangeActive(index);
  showPreviewName.value = 'imgViewerShow';
};

const onChangeActive = index => {
  showIndex.value = index;
};
const onAudit = async status => {
  useTaskAudit({
    auditStatus: status,
    projectId: props.projectId,
    queryParams: {
      sceneType: props.projectType,
      taskRecordId: [props.id]
    },
    auditOver() {
      emits('auditOver', taskDetail.value?.nextTaskId);
    }
  });
};

const onMapRefresh = async () => {
  await taskRecordUpdateMap({
    taskRecordId: props.id,
    projectId: props.projectId,
    sceneType: props.projectType
  });
  getTaskDetail();
};

const onDiffMap = () => {
  showPreviewName.value = 'deefMapShow';
};

const picList = ref([]); //图片列表

const initPicList = async () => {
  picList.value = [];
  // 协定服务
  if (props.projectType === 19) {
    const imageTypeReg = new RegExp(/\.bmp|\.jpg|\.png|\.gif|\.jpeg/, 'i');

    questionDetailInfo.value[0].values.forEach(item => {
      // item.url 后缀为图片则push
      if (imageTypeReg.test(item.url)) {
        picList.value.push(item.url);
      }
    });
  } else {
    questionDetailInfo.value.forEach(item => {
      if (item.topicType === -3) {
        item.values && picList.value.push(item.values);
      }
      if (item.topicType === 20) {
        item.values && picList.value.push(item.values);
      }

      if (item.topicType === 13) {
        item.values &&
          item.values.forEach(item => {
            picList.value.push(item.url);
          });
      }
      if (item.topicType === 16) {
        item.values &&
          item.values.addressPicUrl &&
          picList.value.push(item.values.addressPicUrl);
      }
    });
  }
  if (props.projectType !== 17 && !picList.value.length) {
    showPreviewName.value = '';
  }
};

watch(
  () => showIndex.value,
  () => {
    showPreviewName.value = '';
    nextTick(() => {
      showPreviewName.value = 'imgViewerShow';
    });
  }
);

const getTaskDetail = async () => {
  const { data } = await taskRecordDetail({
    id: props.id,
    dataState: props.dataState,
    projectId: props.projectId,
    sceneType: props.projectType,
    searchVal: props.searchVal
  });
  taskDetail.value = data;
  initPicList();
};
getTaskDetail();
const onClose = () => {
  props.remove();
};
const handleEsc = event => {
  if (event.key === 'Escape') {
    onClose();
  }
};
onMounted(async () => {
  window.addEventListener('keydown', handleEsc);
});
onUnmounted(() => {
  window.removeEventListener('keydown', handleEsc);
});

return (_ctx: any,_cache: any) => {
  const _directive_resource = _resolveDirective("resource")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", {
            onClick: onClose,
            style: {"cursor":"pointer"}
          }, [
            _createVNode(_unref(BaseSvg), {
              style: {"width":"20px","height":"20px"},
              iconClass: "close"
            })
          ])
        ]),
        _createElementVNode("div", {
          style: _normalizeStyle(auditShow.value ? 'height: calc(100vh - 160px)' : 'height: 100%'),
          class: "overlay-right-main"
        }, [
          _createElementVNode("div", null, [
            (isUnqualified.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
              : _createCommentVNode("", true),
            (isPicRepeat.value)
              ? (_openBlock(), _createBlock(_unref(BaseRow), {
                  key: 1,
                  style: {"padding":"5px 5px","text-align":"left"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _hoisted_8,
                      _hoisted_9,
                      _hoisted_10,
                      _createTextVNode(" 标记任务记录内提交的图存在重复, "),
                      _createVNode(_unref(BaseButton), {
                        type: "text",
                        onClick: repeatPickurePerview,
                        style: {"color":"#409eff","text-decoration":"underline"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 点击查看 ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(taskDetail.value?.username || '-') + " ", 1),
                _hoisted_14,
                _createTextVNode(" " + _toDisplayString(taskDetail.value?.phone || '-'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", null, _toDisplayString(_unref(formatter).date(taskDetail.value?.editStatusAt)), 1)
            ]),
            (_ctx.projectType === 19)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", null, _toDisplayString(_unref(formatter).fen2yuan(taskDetail.value?.price)), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              (_ctx.projectType === 21)
                ? (_openBlock(), _createBlock(_unref(BaseButton), {
                    key: 0,
                    type: "primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showPreviewName.value = 'informationShow'))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 查看资讯 ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _hoisted_21,
            _createElementVNode("div", null, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(compNames.value), {
                isShowMapHandleBtn: _ctx.isShowMapHandleBtn,
                questionInfo: questionDetailInfo.value,
                onChangeImgUrl: onChangeImgUrl,
                onMapRefresh: onMapRefresh,
                onDiffMap: onDiffMap
              }, null, 40, ["isShowMapHandleBtn", "questionInfo"]))
            ])
          ])
        ], 4),
        (auditShow.value)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", null, [
                _createVNode(_unref(BaseButton), {
                  disabled: 
                taskDetail.value?.buttonOnOff === 0 || taskDetail.value?.buttonOnOff === 2
              ,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (onAudit(2))),
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 通过 ")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_unref(BaseButton), {
                  disabled: taskDetail.value?.buttonOnOff === 0,
                  type: "default",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (onAudit(3))),
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 不通过 ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ])), [
              [_directive_resource, ['任务记录_审核任务']]
            ])
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_23, [
        (showPreviewName.value === 'informationShow')
          ? (_openBlock(), _createBlock(CPreview, {
              key: 0,
              projectType: props.projectType,
              informationId: taskDetail.value?.informationId,
              projectId: props.projectId,
              taskId: props.id
            }, null, 8, ["projectType", "informationId", "projectId", "taskId"]))
          : _createCommentVNode("", true),
        (showPreviewName.value === 'imgViewerShow')
          ? (_openBlock(), _createBlock(_unref(BaseImageViewer), {
              key: 1,
              previewTeleported: true,
              infinite: true,
              "preview-src-list": picList.value,
              "initial-index": showIndex.value,
              "hide-close": true
            }, null, 8, ["preview-src-list", "initial-index"]))
          : _createCommentVNode("", true),
        (showPreviewName.value === 'deefMapShow')
          ? (_openBlock(), _createBlock(DeefMap, {
              key: 2,
              projectType: props.projectType,
              projectId: props.projectId,
              taskRecordId: props.id,
              dataState: taskDetail.value?.dataState
            }, null, 8, ["projectType", "projectId", "taskRecordId", "dataState"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})